export enum SharedStoreSlices {
	// libs/shared/company/src/lib/data/company.store.ts
	Company = 'company',
	// libs/shared/products/src/lib/data/product.store.ts
	Products = 'products',
	// libs/shared/notifications/src/lib/data/store/notifications/notification/notification.store.ts
	Notifications = 'notifications',
	// libs/shared/ui/toast/src/lib/data/toast.store.ts
	Toast = 'toast',
	// libs/shared/user/src/lib/data/user.store.ts
	User = 'user'
}
